import { MembershipTypeMethod, UserDegreeSegmentationEnum } from "../../__generated__/graphql-schema.js";
import { B2B_ORGANIZATION_ASSIGNED_TYPES } from "../constants.js";
const getStudentType = ({ loading, error, user })=>{
    const { segmentation, isStaff, isMentor, isProfessor, isAffiliate, hasMembership, membership, hasOrganization, organization, userDegreeSegmentation } = user || {};
    const isAnonymous = !loading && !error && !user;
    const isActiveDegree = userDegreeSegmentation === UserDegreeSegmentationEnum.ACTIVATED_DEGREE_SEGMENTATION;
    const isExpiredDegree = userDegreeSegmentation === UserDegreeSegmentationEnum.EXPIRED_DEGREE_SEGMENTATION;
    const isPremium = hasMembership || 'Member' === segmentation;
    const isPremiumTrial = membership?.membershipType?.method === MembershipTypeMethod.A_2;
    const isB2B = hasOrganization || 'B2B' === segmentation;
    const isB2BAllCatalog = organization?.assignedType === B2B_ORGANIZATION_ASSIGNED_TYPES.ALL_CATALOG;
    const isB2BOnlyPanel = organization?.assignedType === B2B_ORGANIZATION_ASSIGNED_TYPES.ONLY_PANEL;
    const organizationRole = organization?.myRole;
    const isB2BAdmin = isB2B && ('admin' === organizationRole || 'owner' === organizationRole || 'owner-corporation' === organizationRole);
    const isNewUser = 'Register' === segmentation;
    const isPAYG = !isAnonymous && !isPremium && !isPremiumTrial && !isActiveDegree && !isB2B;
    let studentType;
    if (user) studentType = isActiveDegree ? 'degree' : isB2B ? 'b2b' : isPremium ? isPremiumTrial ? 'premium-trial' : 'premium' : isNewUser ? 'register' : 'payg';
    else if (isAnonymous) studentType = 'anonymous';
    return {
        loading: !!loading,
        error: !!error,
        studentType,
        isAnonymous,
        isActiveDegree,
        isExpiredDegree,
        isB2B,
        isB2BAllCatalog,
        isB2BOnlyPanel,
        isB2BAdmin,
        isPremium,
        isPremiumTrial,
        isPAYG,
        isNewUser,
        isStaff: !!isStaff,
        isMentor: !!isMentor,
        isTeacher: !!isProfessor,
        isAffiliate: !!isAffiliate
    };
};
const utils_getStudentType = getStudentType;
export default utils_getStudentType;
export { getStudentType };
